import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "../../lib/cn";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "primary" | "ghost" | "link";
  size?: "default" | "sm" | "lg" | "icon";
  asChild?: boolean;
}

const variantStyles: Record<string, string> = {
  default:
    "inline-flex items-center justify-center rounded-lg border border-line bg-white/[0.02] text-foreground transition hover:-translate-y-px hover:border-line-strong hover:bg-white/5",
  primary:
    "inline-flex items-center justify-center rounded-lg border border-accent-ring bg-accent-soft text-foreground transition hover:-translate-y-px hover:border-line-strong hover:bg-white/5",
  ghost:
    "inline-flex items-center justify-center bg-transparent border-0 text-foreground hover:bg-white/5 transition",
  link: "bg-transparent border-0 p-0 text-foreground hover:underline",
};

const sizeStyles: Record<string, string> = {
  default: "px-2.5 py-1 text-sm",
  sm: "px-2.5 py-[0.45rem] text-sm",
  lg: "min-h-12 px-[1.1rem] text-sm",
  icon: "h-9 w-9",
};

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "default", size = "default", asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        ref={ref}
        className={cn(
          variantStyles[variant],
          sizeStyles[size],
          "font-medium disabled:pointer-events-none disabled:opacity-50",
          className,
        )}
        {...props}
      />
    );
  },
);
Button.displayName = "Button";

export { Button, type ButtonProps };
